/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import {
  Box,
  Divider,
  Drawer,
  List,
  makeStyles,
  useTheme,
  withStyles
} from "@material-ui/core";
import React, { useEffect } from "react";
import {
  Clock,
  Cpu,
  Crosshair,
  LogIn,
  Archive as OldPlatformIcon,
  Settings,
  Users as UsersIcon
} from "react-feather";
import PerfectScrollbar from "react-perfect-scrollbar";
import { matchPath, useLocation } from "react-router";
import version from "../../../shared/version";

import {
  AccountBalanceWalletRounded,
  BarChart,
  Battery60Sharp,
  Home,
  Language,
  LocalAtm,
  LocalAtmSharp,
  LocalLibraryTwoTone,
  MonetizationOn,
  Money,
  Payment,
  PaymentSharp,
  PlaylistAddCheck,
  Policy,
  Room,
  TrendingUp
} from "@material-ui/icons";

import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import Logo from "../../../components/Logo";
import { THEMES } from "../../../constants";
import useSettings from "../../../hooks/useSettings";
import NavItem from "./NavItem";

const navConfig = [
  {
    items: [
      {
        title: "Главная",
        icon: Home,
        href: "/app"
      },
      {
        title: "Платежи (НП)",
        icon: LocalAtmSharp,
        href: "/app/management/payment-transactions"
      },
      {
        title: "Инкассация (НП)",
        icon: PaymentSharp,
        href: "/app/management/encashments",
        items: [
          {
            title: "Инкассированые",
            icon: Payment,
            href: "/app/management/encashments"
          },
          {
            title: "Не инкассированые",
            icon: Payment,
            href: "/app/management/manual-encashment"
          }
        ]
      },
      {
        title: "Инкассация кэшаута",
        icon: MonetizationOn,
        href: "/app/management/cashout-encashments"
      },

      {
        title: "Кешаут транзакции",
        icon: Money,
        href: "/app/management/cashout-transactions"
      },
      {
        title: "Кассеты кэшаута",
        icon: Money,
        href: "/app/management/cashout-cassettes"
      },
      {
        title: "Балансы по кешауту",
        icon: Money,
        href: "/app/management/cashout-balances"
      },
      {
        title: "Балансы агентов",
        icon: Money,
        href: "/app/management/agent-balances"
      },
      {
        title: "Мониторинг (НП)",
        icon: TrendingUp,
        href: "/app/management/monitoring-new"
      },
      // create list of home-screen, providers and category
      {
        title: "Провайдеры",
        icon: Cpu,
        items: [
          {
            title: "Категории",
            icon: Crosshair,
            href: "/app/management/category"
          },
          {
            title: "Провайдеры",
            icon: Cpu,
            href: "/app/management/provider"
          },
          {
            title: "Главный экран",
            icon: Home,
            href: "/app/management/home-screen"
          }
        ]
      },
      {
        title: "История статусов",
        icon: TrendingUp,
        href: "/app/management/statuses"
      },
      {
        title: "Сумма терминалов",
        icon: AccountBalanceWalletRounded,
        href: "/app/management/balances"
      },
      {
        title: "Балансы терминалов",
        icon: BarChart,
        href: "/app/management/bookkeeping"
      },
      {
        title: "ЮзерЛоги",
        icon: LocalLibraryTwoTone,
        href: "/app/management/userLogs"
      },

      {
        title: "Проводки",
        icon: Battery60Sharp,
        items: [
          {
            title: "Кешин",
            href: "/app/management/postsListView",
            icon: Battery60Sharp
          },
          {
            title: "Кешаут",
            href: "/app/management/postsListView/cashout",
            icon: Battery60Sharp
          }
        ]
      },

      {
        title: "Местоположение",
        icon: Room,
        href: "/app/management/locations"
      },

      {
        title: "Сервисы",
        icon: Settings,
        href: "/app/management/services"
      },
      {
        title: "Команды терминала",
        icon: Clock,
        href: "/app/management/scheduled-command"
      },
      {
        title: "Вход в терминал",
        icon: LogIn,
        href: "/app/management/terminal-buttons"
      },
      {
        title: "Запросы на сброс",
        icon: PlaylistAddCheck,
        href: "/app/management/reset-requests"
      },

      {
        title: "Права",
        icon: Policy,
        href: "/app/management/policies"
      },

      {
        title: "Пользователи",
        icon: UsersIcon,
        href: "/app/management/users"
      },
      {
        title: "Мультиязычность",
        href: "/app/management/languages",
        icon: Language
      },
      {
        title: "Старая платформа",
        icon: OldPlatformIcon,
        href: "/app/management/payments",
        items: [
          {
            title: "Платежи",
            icon: LocalAtm,
            href: "/app/management/payments"
          },
          {
            title: "Кэшаут операции",
            icon: Money,
            href: "/app/management/cashout"
          },
          {
            title: "Инкассация",
            icon: Payment,
            href: "/app/management/banknotes"
          },

          {
            title: "Мониторинг",
            icon: TrendingUp,
            href: "/app/management/monitoring"
          }
        ]
      }
    ]
  }
];

const useStyles = makeStyles(() => ({
  openDrawer: {
    width: 256,
    borderRight: "none",
    boxShadow: "0 0 10px -4px black",
    transition: "0.25s"
  },
  hiddenDrawer: {
    width: 51,
    borderRight: "none",
    boxShadow: "0 0 10px -4px black",
    transition: "0.25s",
    overflowX: "hidden"
  }
}));

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 18,
    height: 10,
    padding: 0,
    display: "flex"
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(8px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main
      }
    }
  },
  thumb: {
    width: 6,
    height: 6,
    boxShadow: "none"
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 10 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white
  },
  checked: {}
}))(Switch);

function renderNavItems({ items, autoHideEnabled, hovered, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) =>
          reduceChildRoutes({ acc, item, autoHideEnabled, hovered, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
      />
    );
  }

  return acc;
}

function NavBar({ autoHideEnabled, setAutoHideEnabled }) {
  const classes = useStyles();
  const theme = useTheme();
  const { saveSettings } = useSettings();
  const location = useLocation();
  const [hovered, setHovered] = React.useState(false);

  useEffect(() => {
    saveSettings({ autoHide: autoHideEnabled });
  }, [autoHideEnabled]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box p={2} style={{ display: "flex" }}>
        <Logo dark={theme.name === THEMES.DARK} />
        <Box ml={1} display="flex" justifyContent="center">
          <AntSwitch
            checked={autoHideEnabled}
            onChange={() => {
              setAutoHideEnabled(!autoHideEnabled);
            }}
          />
        </Box>
      </Box>
      <Divider />
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box p={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
          {navConfig.map((config, index) => (
            <List key={index}>
              {renderNavItems({
                items: config.items,
                pathname: location.pathname
              })}
            </List>
          ))}
        </Box>
        <Typography
          style={{ marginLeft: "60px" }}
          variant="caption"
          color="textSecondary"
        >
          version: {version}
        </Typography>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Drawer
        anchor="left"
        classes={{
          paper: autoHideEnabled
            ? hovered
              ? classes.openDrawer
              : classes.hiddenDrawer
            : classes.openDrawer
        }}
        open
        variant="persistent"
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
      >
        {content}
      </Drawer>
    </>
  );
}

NavBar.propTypes = {};

export default NavBar;
